import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../../common";
import { getToken } from "../../../features/user/UserAvatar";
import { SuggestionDetailsInfo } from "./suggestionDetailsSlice";

export interface SuggestionDetailsListState {
  state: LoadStateInfo;
  request?: RetrieveSuggestionDetailsListRequest;
  list?: SuggestionDetailsInfo[];
}

const initialState: SuggestionDetailsListState = {
  state: notStarted(),
};

export interface RetrieveSuggestionDetailsListRequest {
  faceId: string;
}

export const retrieveSuggestionDetailsList = createAsyncThunk(
  "retrieveSuggestionDetailsList",
  async (params: RetrieveSuggestionDetailsListRequest, thunkAPI) => {
    console.debug("retrieveSuggestionDetailsList");

    const response = await fetch(`${getBackendUrl()}/api/face/${params.faceId}/suggestions`, {
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
      method: "GET",
    });

    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);


export const suggestionDetailsListSlice = createSlice({
  name: "suggestionDetailsListSlice",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    check: (state, action: PayloadAction<RetrieveSuggestionDetailsListRequest>) => {
      if( state.request?.faceId != action.payload.faceId ) {
        state.state = notStarted();
        state.request = action.payload;
      }
    },
    clean: (state) => {
      state.state = notStarted();
      state.list = undefined;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(retrieveSuggestionDetailsList.pending, (state, action) => {
        state.state =  loading();
        state.list = undefined;
      })
      .addCase(retrieveSuggestionDetailsList.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.list = action.payload;
        state.list?.sort((a, b) => a.suggestedFace.l2 - b.suggestedFace.l2);
      })
      .addCase(retrieveSuggestionDetailsList.rejected, (state, action) => {
        state.state = error(action);
      });
    },
});

export const { } = suggestionDetailsListSlice.actions;

export const selectSuggestionDetailsList = (state: RootState) => state.suggestionDetailsList;

export default suggestionDetailsListSlice.reducer;
